import dashboard from '../frontEnd/es/dashboard.json'
import findProducts from '../frontEnd/es/findProducts.json'
import common from '../frontEnd/es/common.json'
import frameClass from '../frontEnd/es/frameClass.json'
import sourcing from '../frontEnd/es/sourcing.json'
import listProduct from '../frontEnd/es/listProduct.json'
import orders from '../frontEnd/es/orders.json'
import customService from '../frontEnd/es/customService.json'
import siteOptimization from '../frontEnd/es/siteOptimization.json'
import subscribe from '../frontEnd/es/subscribe.json'
import setting from '../frontEnd/es/setting.json'
import shoppingCart from '../frontEnd/es/shoppingCart.json'
import message from '../frontEnd/es/message.json'
import partnership from '../frontEnd/es/partnership.json'
const es =  {
    ...dashboard,
    ...findProducts,
    ...common,
    ...frameClass,
    ...sourcing,
    ...listProduct,
    ...orders,
    ...customService,
    ...siteOptimization,
    ...subscribe,
    ...setting,
    ...shoppingCart,
    ...message,
    ...partnership
};
export default es;